import {useHistory, useLocation} from 'react-router-dom';
import React, {useEffect, useMemo, useRef, useState} from 'react';
import { Element, scroller } from 'react-scroll';
import { Form, Toast, Card } from 'react-bootstrap';
import useNavProject from '../../../hooks/useNavProject';
import useAPI from '../../../hooks/useAPI';
import useUserContext from '../../../hooks/useUserContext';
import useToast from '../../../hooks/useToast';
import { _default } from '../../project/helpers/passport';
import { getActionsModel } from '../../../services/roles/policyProjRoleStatus';
import { checkDatesFull } from '../../../components/project/PassportEdit/helpers/validation';
import { makeUID, stepScroll } from '../../../helpers';
import BackBtn from '../../../components/UI/BackBtn';
import ProjectScrollBox from '../../../components/project/Partials/ProjectScrollBox';
import StatusBadge from '../../../components/project/PassportRead/StatusBadge';
import CommonInfo from '../../../components/project/PassportEdit/CommonInfo';
import Contents from '../../../components/project/PassportEdit/Contents';
import Results from '../../../components/project/PassportEdit/Results';
import Indicators from '../../../components/project/PassportEdit/Indicators';
import Budget from '../../../components/project/PassportEdit/Budget';
import TeamMembers from '../../../components/project/PassportEdit/TeamMembers';
import Participants from '../../../components/project/PassportEdit/Participants';
import ButtonsCard from '../../../components/project/PassportEdit/ButtonsCard';
import {getFixedPcs} from "../../../requests/exportRequests";
import {saveMilestones, saveProj} from "../../../requests/ProjectRequest/projectRequest";
import {checkParamExists} from "../../../helpers/location";
import Attachments from '../../../components/project/PassportEdit/Attachments';
import useProjectMilestones from "../../../hooks/useProjectMilestones";
import Milestones from "../../../components/project/PassportEdit/Milestones";
import {BaseRequests} from "../../../requests/BaseRequests";
import ProjectImpactTable from '../../../components/project/Partials/ProjectImpactTable';

export default function PolicyProjectPassportEdit({
  policyId, projId, mngData, periods, enableReadMode, isLatestVersion,
}) {
  const history = useHistory();
  const navProject = useNavProject();
  const formEl = useRef(null);
  const api = useAPI();
  const userCtx = useUserContext();
  const addToast = useToast();
  const location = useLocation();
  const [proj, setProj] = useState(_default.project(0, projId, policyId));
  const [validated, setValidated] = useState(false);
  const [err, setErr] = useState(false);
  const [resultMsg, setResultMsg] = useState(null);
  const [show, setShow] = useState(false);
  const [validationFailedTeamMembers, setValidationFailedTeamMembers] = useState(false);
  const [fixedPcsData,setFixedPcs] = useState([])
  const [attachmentsValidation, setAttachmentsValidation] = useState(true)
  const [trls, setTrls] = useState([])
  const [milestones, setMilestones] = useState([])
  const [milestonesGenerated, setMilestonesGenerated] = useState(false)
  const [startValidatingMilestones, setStartValidatingMilestones] = useState(false);
  const [isValidatingMilestones, setIsValidatingMilestones] = useState(false);
  const isLinkedFromMilestones = useRef(checkParamExists(location, 'milestones=1'))
  const isLinkedFromHistory = useRef(checkParamExists(location,'isHistory=1'))
  const isNewProject = useMemo(() => projId === 'new', [projId]);

  useEffect(async () => {
    const fetchedProj = await getProj(proj.id);
    const can = getActionsModel(fetchedProj.status, userCtx, policyId, fetchedProj.originId, isLatestVersion);
    if (projId !== 'new' && !can.Edit && !can.EditCurrent && !can.EditCurrentMilestones) {
      addToast.error('Недостаточно прав для редактирования ЦП проекта');
      history.push(`/policies/${policyId}/projs/${projId}`);
    }
    if (location.search.split('&').includes('milestones=1')){
      scroller.scrollTo('Milestones', stepScroll)
    }
  }, []);

  useEffect(async () => {
    try {
      const fetchedTrls = await api.get('/mng/trls')
      setTrls(fetchedTrls)
    }
    catch (e){
      addToast.error('Произошла неизвестная ошибка')
    }
  }, [])

  const switchToReadMode = () => {
    enableReadMode();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (isLinkedFromMilestones.current){
      if (validateMilestones()) {
        const resp = await saveMilestones(milestones, projId)
        if (resp.success){
          addToast.success('Вехи успешно сохранены');
          setShow(true);
          setErr(false);
          !!enableReadMode && enableReadMode(isNewProject ? res.id : isLinkedFromHistory.current);
        }
        else {
          setResultMsg(resp.err?.message || 'Не удалось сохранить вехи');
          setShow(true);
          setErr(true);
        }
      }
      setRequestPending(false)
      return
    }
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      const invalidEl = formEl.current.querySelector(':invalid');
      invalidEl.scrollIntoView({ block: 'center', behavior: 'smooth' });
    } else if (validateTeamMembers() && !checkDatesFull(proj.startDate, proj.endDate)  && validateAttachmentFiles() && validateMilestones() && validateScienceTechFields()) {
      let newMilestonesCounter = -1;
      const resProj = {...proj, milestones: milestones.map((v) => {
              if (!v.id){
                newMilestonesCounter--
                return {...v, id: -newMilestonesCounter}
              }
              return v
            })}
      await saveProj(api,resProj,addToast,
          {
            setShow,setErr,enableReadMode: !isNewProject
                ? enableReadMode
                : (id)=>history.replace(`/policies/${policyId}/projs/${id}`)
            ,setResultMsg,isLinkedFromHistory,isNewProject
          });
    }
    setValidated(true);
  };

  const validateTeamMembers = () => {
    const requiredRoles = ['head', 'admin', 'employer'];
    const validTeamMembers = proj.users && requiredRoles.every((role) => proj.users.find((user) => user.role === role));
    if (!validTeamMembers) {
      addToast.error('Необходимо назначить все обязательные роли Команды управления');
      scroller.scrollTo('Participants', stepScroll);
      setValidationFailedTeamMembers(true);
    }
    return validTeamMembers;
  };


  // const saveProj = async () => {
  //   const res = await api.post(`/projs/${proj.id}`, proj);
  //   if (res.id) {
  //     addToast.success('Проект успешно сохранен');
  //     setShow(true);
  //     setErr(false);
  //     history.push(`/policies/${policyId}/projs/${res.id}`);
  //   } else {
  //     setResultMsg(res.error && res.error.message || 'Не удалось сохранить проект');
  //     setShow(true);
  //     setErr(true);
  //   }
  // };

  const getProj = async (id) => {
    if (id) {
      const resProj = await api.get(`/projs/${id}`);
      const respProjectStructure = await api.get(`/structure/projs/${id}`);
      const teamMembers = await api.get(
          BaseRequests.getUrlSearch('/factdata/teammembers',{projId})
      )
      const policyName = respProjectStructure.policy.name;

      navProject.setProjTitle(respProjectStructure.name);
      navProject.setPolicyTitle(policyName);

      const newProj = {
        ...resProj,
        strategyName: 'Отсутствует',
        policyName,
        users: resProj.users.map((u) => ({ ...u, hash: makeUID(5) })),
        startDate: resProj.startDate ? resProj.startDate.substring(0, 10) : undefined,
        endDate: resProj.endDate ? resProj.endDate.substring(0, 10) : undefined,
        approvedOn: resProj.approvedOn ? resProj.approvedOn.substring(0, 10) : undefined,
        attachments: resProj.attachments.sort((a, b) => new Date(a.createdOn) - new Date(b.createdOn)) || [],
        teamMembers
      };

      setProj(newProj);
      return newProj;
    }
    const resPolicies = await api.get('/mng/strategies?isPortfolio=true');
    const policyName = proj.policyId ? resPolicies.find((s) => s.id === parseInt(proj.policyId)).name : '';

    navProject.setProjTitle('Новый проект');
    navProject.setPolicyTitle(policyName);

    const newProj = {
      ...proj,
      strategyName: 'Отсутствует',
      policyName,
    };
    setProj(newProj);
    return newProj;
  };

  const onProjFieldValueUpdate = (value, field) => {
    setProj({ ...proj, [field]: value });
  };

  const validateAttachmentFiles = () => {
    const isValid = proj.attachments && proj.attachments.every((value) => !!value.file && !value.id || value.id);
    if (!isValid){
      scroller.scrollTo('Attachments', stepScroll)
      setAttachmentsValidation(false)
    }
    return isValid
  }

  const validateMilestones = () => {
    setIsValidatingMilestones(true)
    setStartValidatingMilestones((prevState) => !prevState)
    return milestones.every((value) => value.name && value.personsInCharge && value.personsInCharge[0] && value.monthPlan && value.yearPlan)
  }

  const validateScienceTechFields = () => {
    if(proj.typeId === 3){
      const validityCommon = proj.grntis && proj.grntis.length > 0 && proj.mainSciTechDirectionId;
      const validityResults = proj.criticalTechId && proj.endToEndTechId;
      if(!validityCommon){
        scroller.scrollTo('CommonInfo');
        addToast.error('Заполните все обязательные поля');
      } else if (!validityResults){
        scroller.scrollTo('Results');
        addToast.error('Заполните все обязательные поля');
      }
      return validityCommon && validityResults;
    }
    return true
  }

  useEffect(()=>{
    async function fetchFixedPcs(){
      const responseFixedPcsData = await getFixedPcs(api,addToast)
      setFixedPcs(responseFixedPcsData)
    }
    fetchFixedPcs()
  },[])

  useProjectMilestones(setMilestones, proj, setMilestonesGenerated)

  return (
    <section className="page form-page project-card-page">
      <div className="container">
        <div style={{ marginBottom: 16 }}>
          <BackBtn />
        </div>

        <ProjectScrollBox />

        <div style={styledContainer}>
          <h4 style={styledSubHeading}>
            {projId === 'new' || !proj.name ? 'Цифровой паспорт' : proj.name}
          </h4>
          {proj.status && <div><StatusBadge status={proj.status} /></div>}
        </div>

        <Form
          noValidate
          validated={validated}
          onSubmit={handleSubmit}
          ref={formEl}
        >
          <Element id="CommonInfo" name="CommonInfo">
            <CommonInfo
              data={proj}
              onChange={(value, field) => onProjFieldValueUpdate(value, field)}
              letters={mngData.letters}
              kpis={mngData.kpis}
              types={mngData.projTypes}
              policies={mngData.policies}
              validated={validated}
              disabled={isLinkedFromMilestones.current}
            />
          </Element>
          <Element id="Contents" name="Contents">
            <Contents
              data={proj}
              onChange={(value, field) => onProjFieldValueUpdate(value, field)}
              disabled={isLinkedFromMilestones.current}
            />
          </Element>
          <Element id="Results" name="Results">
            <Results
              data={proj}
              periods={periods}
              onChange={(value, field) => onProjFieldValueUpdate(value, field)}
              letters={mngData.letters}
              resultTypes={mngData.resultTypes}
              disabled={isLinkedFromMilestones.current}
            />
          </Element>
          <Element id='Milestones' name='Milestones'>
            <Milestones
                teamMembers={proj.teamMembers}
                projectStatus={proj.status}
                milestones={milestones}
                onChange={setMilestones}
                trls={trls}
                isValidating={isValidatingMilestones}
                startValidating={startValidatingMilestones}
                correctDates={{minDate: new Date(proj.startDate), maxDate: new Date(proj.endDate)}}
                milestonesGenerated={milestonesGenerated}
            />
          </Element>
          <Element id="Indicators" name="Indicators">
            <Indicators
              data={proj}
              fixedPcs={fixedPcsData}
              periods={periods}
              onChange={(value, field) => onProjFieldValueUpdate(value, field)}
              disabled={isLinkedFromMilestones.current}
            />
          </Element>
          <Element id="Budget" name="Budget">
            <Budget
              data={proj.plans}
              start={proj.startDate ? new Date(proj.startDate).getFullYear() : null}
              end={proj.endDate ? new Date(proj.endDate).getFullYear() : null}
              periods={periods}
              onChange={(value, field) => onProjFieldValueUpdate(value, field)}
              finSources={mngData.finSources.filter((s) => s.type === 'sf')}
              disabled={isLinkedFromMilestones.current}
            />
          </Element>
          <Element id="Participants" name="Participants">
            <TeamMembers
              data={proj.users}
              onChange={(value, field) => onProjFieldValueUpdate(value, 'users')}
              userRoles={mngData.userRoles}
              validationFailed={validationFailedTeamMembers}
              disabled={isLinkedFromMilestones.current}
            />
          </Element>
          <Element id="Participants2" name="Participants2">
            <Participants
              data={proj.approvers}
              onChange={(value, field) => onProjFieldValueUpdate(value, 'approvers')}
              disabled={isLinkedFromMilestones.current}
            />
          </Element>
          <Element id="Attachments" name="Attachments">
            <Attachments
              data={proj}
              onChange={(value, field) => onProjFieldValueUpdate(value, field)}
              isValid={attachmentsValidation}
              disabled={isLinkedFromMilestones.current}
            />
          </Element>
          <div style={{position:"sticky", bottom:"0", zIndex:"100"}}>
            <ButtonsCard
              projId={proj.id}
              switchToReadMode={switchToReadMode}
            />
          </div>
        </Form>
      </div>
      <Toast
        style={{
          position: 'fixed', top: 0, right: 0, color: 'white', zIndex: 1500
        }}
        className="d-inline-block m-1"
        bg={!err ? 'info' : 'danger'}
        onClose={() => setShow(false)}
        show={show}
        delay={5000}
        autohide
      >
        <Toast.Body>
          {resultMsg}
        </Toast.Body>
      </Toast>
    </section>
  );
}

const styledSubHeading = { marginBottom: 24, lineHeight: '23px' };
const styledContainer = { display: 'flex', marginTop: 36, justifyContent: 'space-between' };
